import { takeLatest, put, call } from 'redux-saga/effects';

import { findAllTransportadoraCadastro } from '../service';
import {
  LIST_TRANSPORTADORA_CADASTRO,
  LIST_TRANSPORTADORA_CADASTRO_PENDING,
  LIST_TRANSPORTADORA_CADASTRO_SUCCESS,
  LIST_TRANSPORTADORA_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaListAllTransportadoraCadastro(action) {
  yield put({ type: LIST_TRANSPORTADORA_CADASTRO_PENDING })

  try {
    const list = yield call(findAllTransportadoraCadastro)
    
    yield put({ type: LIST_TRANSPORTADORA_CADASTRO_SUCCESS, list: list })
  } catch (error) {

    yield put({ type: LIST_TRANSPORTADORA_CADASTRO_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListAllTransportadoraCadastro() {
  yield takeLatest(LIST_TRANSPORTADORA_CADASTRO, sagaListAllTransportadoraCadastro)
}